import React from "react";
import { useTranslation } from "react-i18next";

import SplashScreen from "@/components/SplashScreen";
import { useDisableThreatNotifications } from "@/pages/landing-pages/api";
import css from "@/pages/landing-pages/components/LandingPage.module.css";
import LandingPageLayout, {
  SupportedLanguage,
} from "@/pages/landing-pages/components/LandingPageLayout";
import {
  browserLanguage,
  useOnlyOnceEffect,
} from "@/pages/landing-pages/utils";

type DisableThreatNotificationPageProps = {
  lang: SupportedLanguage;
  isLoading: boolean;
  isError: boolean;
};

export const DisableThreatNotificationPage = ({
  lang,
  isLoading,
  isError,
}: DisableThreatNotificationPageProps) => {
  const { t, ready } = useTranslation("landing", { lng: lang });
  if (isLoading || !ready) {
    return <SplashScreen />;
  }

  return (
    <LandingPageLayout>
      {isError ? (
        <div>{t("landing.UnknownError")}</div>
      ) : (
        <p className={css.message}>
          {t("landing.DisableThreatNotification.success")}
        </p>
      )}
    </LandingPageLayout>
  );
};

export function DisableThreatNotifications() {
  const browser_language = browserLanguage();
  const { disableThreatNotifications, isError, isLoading } =
    useDisableThreatNotifications();

  useOnlyOnceEffect(() => {
    disableThreatNotifications();
  });

  return (
    <DisableThreatNotificationPage
      lang={browser_language}
      isError={isError}
      isLoading={isLoading}
    />
  );
}
